module.exports = __webpack_public_path__ + "img/IMAGE 4.7ef9d8f3.png";